/**
 * Default WIDTH for the Document Picture-in-Picture window.
 */
export const DEFAULT_DOCUMENT_PIP_WIDTH = 284;
/**
 * Default HEIGHT for the Document Picture-in-Picture window.
 */
export const DEFAULT_DOCUMENT_PIP_HEIGHT = 160;
